import _ from 'lodash';

const layouts = {
  LIST:  'list',
  GROUP: 'group',
};

layouts.ALL = _.values(layouts);

export default layouts;
